import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ChatVideoLink } from "@redotech/redo-web/ai/chat/components/chat-video-link";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export const CUSTOM_ANALYTICS_REPORTS_LINK =
  "/order-management/analytics/reports?tab=custom";

function isCustomAnalyticsReportsLink(href: string): boolean {
  return href === CUSTOM_ANALYTICS_REPORTS_LINK;
}

export function CustomAnalyticsReportMarkdownLink({
  href,
  children,
}: {
  href: string;
  children?: ReactNode;
}) {
  const navigate = useNavigate();
  const routes = useRequiredContext(MerchantRoutesContext);

  if (!isCustomAnalyticsReportsLink(href)) {
    return <ChatVideoLink href={href}>{children}</ChatVideoLink>;
  }

  return (
    <Flex dir="column" mt="sm" w="full">
      <RedoButton
        hierarchy="primary"
        onClick={() => navigate(`${routes.analyticsReportsHref}?tab=custom`)}
        size="sm"
        text="View custom reports"
      />
    </Flex>
  );
}
